if (!customElements.get('fu-tabs')) customElements.define('fu-tabs', class extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;
    const tabs = [...this.querySelectorAll('[role=tab]')];
    const panels = [...this.querySelectorAll('.fu-tab-panel')];
    const tabList = this.querySelector('[role=tablist]');
    if (!tabs.length || tabs.length !== panels.length || !tabList) return;
    tabList.hidden = false;
    this.classList.add('fu-tabs-ready');
    const activate = (index, focus = false) => {
      tabs.forEach((tab, i) => {
        tab.setAttribute('aria-selected', String(i === index));
        tab.tabIndex = i === index ? 0 : -1;
        panels[i].hidden = i !== index;
        panels[i].setAttribute('role', 'tabpanel');
        panels[i].setAttribute('aria-labelledby', tab.id);
        panels[i].tabIndex = 0;
      });
      if (focus) tabs[index].focus();
    };
    tabs.forEach((tab, i) => {
      tab.addEventListener('click', () => activate(i));
      tab.addEventListener('keydown', (event) => {
        let next;
        if (event.key === 'ArrowRight') next = (i + 1) % tabs.length;
        if (event.key === 'ArrowLeft') next = (i - 1 + tabs.length) % tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = tabs.length - 1;
        if (next !== undefined) { event.preventDefault(); activate(next, true); }
      });
    });
    this.addEventListener('shopify:block:select', (event) => {
      const index = panels.findIndex((panel) => panel === event.target || panel.contains(event.target));
      if (index >= 0) activate(index);
    });
    activate(0);
  }
});
